<template>
    <div
        class="header relative flex content-center items-center h-80 bg-center bg-cover"
        :class="headerClass"
        :style="'background-image: url(' + backgroundImage + ')'"
    >
        <div
            class="overlay"
            :style="'opacity: ' + doc.header_overlay_opacity / 100"
        ></div>
        <div class="container mx-auto text-center z-10">
            <h1 class="strong ms-1.5 font-underland">
                {{ doc.header_static_labels ? doc.title : $parent.doc.title }}
            </h1>
            <hr class="w-40 m-2 mx-auto" />
        </div>
    </div>
</template>

<script>
export default {
    name: "SiteHeader",

    props: ["doc"],

    data() {
        return {
            backgroundImage: null
        };
    },

    computed: {
        headerClass() {
            return {
                primary: "inverse bg-primary",
                secondary: "inverse bg-secondary",
                muted: "bg-muted"
            }[this.doc.header_color];
        }
    },

    watch: {
        doc() {
            this.update();
        },
        "doc.header_image"() {
            this.update();
        }
    },

    methods: {
        update() {
            this.$asset(
                {
                    src: this.doc.header_image,
                    w: 1920,
                    h: 450,
                    fit: "crop_focal"
                },
                img => {
                    img && (this.backgroundImage = img.src);
                }
            );
            window.$header = this;

            if (["primary", "secondary"].indexOf(this.doc.header_color) > -1) {
                $("body").addClass("inverse-header");
            }
        }
    },

    mounted() {
        this.update();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/SiteHeader.vue